import React, { useCallback } from 'react';
import { useAuthContext } from '@/contexts/AuthContext';
import { ProfileHeader } from '@/components/profile/ProfileHeader';
import { AnalysisHistory } from '@/components/profile/AnalysisHistory';
import { SubscriptionFeatures } from '@/components/profile/SubscriptionFeatures';
import { Navigate } from 'react-router-dom';

export function ProfilePage() {
  const { user, profile } = useAuthContext();

  const handleSubscriptionUpdate = useCallback(() => {
    // The AuthContext will automatically update when the subscription changes
    // due to the Firestore subscription
  }, []);

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="pt-32 pb-16 px-4">
      <div className="max-w-6xl mx-auto">
        <ProfileHeader user={user} profile={profile} />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <AnalysisHistory userId={user.uid} />
          </div>
          <div>
            <SubscriptionFeatures 
              subscription={profile?.subscription}
              userId={user.uid}
              onSubscriptionUpdate={handleSubscriptionUpdate}
            />
          </div>
        </div>
      </div>
    </div>
  );
}